/**
 * Assistant feature slice.
 *
 * Registered as a shell widget rather than a route: it is reachable from every
 * page and owns no URL. The backend reports `chat` as disabled unless the flag is
 * on *and* an inference credential is configured, so an unkeyed deployment simply
 * never shows the trigger.
 */
import { lazy } from "react";

import type { ShellWidgetDescriptor } from "@/features/types";

export const chatWidget: ShellWidgetDescriptor = {
  id: "chat",
  flag: "chat",
  element: lazy(() => import("./ChatWidget")),
};
